export default "__VITE_ASSET__dolb6uVv__"